import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { publicaciones_item } from "../../../json/publicaciones";
import "./publicaciones.css"


const Publicaciones = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="container transparencia-container">
      <div className="row">
        <div className="col-12">
          <div className="transparencia_title">
            <h1>Publicaciones</h1>
            <hr className="tramitehr" />
          </div>
        </div>
      </div>

            <div className="row">
            {publicaciones_item.map((item, index) => (
              <div className="col-md-4 mb-4" key={index}>
                <div className="card card_new">
                  <div className="card-header text-center text-from-cards text-primary">{item.publicaciones_item_nombre}</div>
                  <div className="card-body text-center">
                    <p className="card-text text-justify">{item.publicaciones_item_leyenda}</p>
                    {item.publicaciones_item_url.includes(".pdf") ? (
                      <a target="_blank" href={item.publicaciones_item_url} className="btn btn-danger rounded-pill"><i class="fa-solid fa-file-pdf"></i>PDF</a>
                    ) : (
                      <a href={item.publicaciones_item_url} className="btn btn-primary rounded-pill">Ver más</a>
                    )}
                  </div>
                </div>
              </div>
            ))}
      </div>
    </div>
  );
};

export default Publicaciones;